<!-- from https://github.com/cnu4/vue-codemirror-lite
     no update in 3 years - adding manually and not as a dependency
-->
<template>
  <div class="vue-codemirror-wrap" style="position: relative">
    <textarea></textarea>
  </div>
</template>

<script>
const CodeMirror = require('codemirror/lib/codemirror.js')
require('codemirror/mode/htmlmixed/htmlmixed.js')
require('codemirror/lib/codemirror.css')
require('codemirror/theme/solarized.css')
// require hint addon for javacript
require('codemirror/addon/hint/show-hint.js')
require('codemirror/addon/hint/show-hint.css')
require('codemirror/addon/hint/javascript-hint.js')
require('codemirror/addon/hint/sql-hint.js')
require('codemirror/mode/sql/sql.js')

export default {
  name: 'codemirror',
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: function () {
        return {
          mode: 'htmlmixed',
          lineNumbers: true,
          lineWrapping: true
        }
      }
    }
  },
  data: function () {
    return {
      skipNextChangeEvent: false
    }
  },
  ready: function () {
    var _this = this
    this.editor = CodeMirror.fromTextArea(
      this.$el.querySelector('textarea'),
      this.options
    )
    this.editor.setValue(this.value)
    this.editor.on('change', function (cm) {
      if (_this.skipNextChangeEvent) {
        _this.skipNextChangeEvent = false
        return
      }
      _this.value = cm.getValue()
      if (_this.$emit) {
        _this.$emit('change', cm.getValue())
      }
    })
  },
  mounted: function () {
    var _this = this
    this.editor = CodeMirror.fromTextArea(
      this.$el.querySelector('textarea'),
      this.options
    )
    this.editor.setValue(this.value)
    this.editor.on('change', function (cm) {
      if (_this.skipNextChangeEvent) {
        _this.skipNextChangeEvent = false
        return
      }
      if (_this.$emit) {
        _this.$emit('change', cm.getValue())
        _this.$emit('input', cm.getValue())
      }
    })
  },
  watch: {
    value: function (newVal, oldVal) {
      var editorValue = this.editor.getValue()
      if (newVal !== editorValue) {
        this.skipNextChangeEvent = true
        var scrollInfo = this.editor.getScrollInfo()
        this.editor.setValue(newVal)
        this.editor.scrollTo(scrollInfo.left, scrollInfo.top)
      }
    },
    options: function (newOptions, oldVal) {
      if (typeof newOptions === 'object') {
        for (var optionName in newOptions) {
          if (newOptions.hasOwnProperty(optionName)) {
            this.editor.setOption(optionName, newOptions[optionName])
          }
        }
      }
    }
  },
  beforeDestroy: function () {
    if (this.editor) {
      this.editor.toTextArea()
    }
  }
}
</script>

<style>
.CodeMirror {
  height: 300vh;
  /* overflow-y: auto; */
  /* overflow-x: auto; */
}
.CodeMirror-code {
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
}
</style>
